import React, { useState, useContext, useCallback, useEffect } from "react";

import {
  FormControlLabel,
  Grid,
  Grow,
  IconButton,
  Switch,
  Tooltip,
  Typography,
} from "@material-ui/core";

import Icon from "@material-ui/core/Icon";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";
import TableDefault from "../../../../components/grid/TableDefault";

import { Header, FormaPagto } from "../styles/Emissao";
import ModalEmissaoFormaPagto from "./ModalEmissaoFormaPagto";
import ModalEmissaoCobranca from "./ModalEmissaoCobranca";

import { EmissaoContext } from "../contexts/EmissaoContext";
import useEmissaoController from "../controllers/EmissaoController";
import { GlobalVariables } from "../../../../GlobalVariables";
import moment from "moment";

const TabEmissaoFormaPagto = ({ ...props }) => {
  const {
    pagtoTableCobranca,
    setPagtoTableCobranca,
    pagtoTableFormaPagto,
    setPagtoTableFormaPagto,
    nfeFinancialIssue,
    visualizationOnly,
    senderClifor,
    itensTotalNfe,
    saleFinanceSwitch,
    headerTypeNfe,
    headerDateJL,
    nfeListPaymentIndicator,
  } = useContext(EmissaoContext);

  const { handleConfirmActionItem, handleDetachDanfe } = useEmissaoController();

  const [modalFormaPagtoOpen, setModalFormaPagtoOpen] = useState(false);
  const [modalCobrancaOpen, setModalCobrancaOpen] = useState(false);
  const [indexCharge, setIndexCharge] = useState(null);
  const [indexPayment, setIndexPayment] = useState(null);

  const handleOpenAndEditCobranca = (indexCharge) => {
    setIndexCharge(indexCharge);
    setModalCobrancaOpen(true);
  };

  const handleOpenAndEditPayment = (indexPayment) => {
    setIndexPayment(indexPayment);
    setModalFormaPagtoOpen(true);
  };

  const rmd = (value = "", fixed = 2) => {
    return parseFloat(
      parseFloat(value.replace(/\./g, "").replace(",", ".")).toFixed(fixed)
    );
  };

  const handleSumParcialAndFullLiquidated = useCallback(() => {
    const sumValue = pagtoTableCobranca.reduce((accumulator, pagto) => {
      if (
        pagto.cobrancaSituacaoValue ===
          GlobalVariables.RecieveSituations.fullyLiquidated ||
        pagto.cobrancaSituacaoValue ===
          GlobalVariables.RecieveSituations.partiallyLiquidated
      ) {
        return accumulator + rmd(pagto?.cobrancaValorPago || "0,00");
      }

      return accumulator + 0;
    }, 0);

    return (
      sumValue >= rmd(itensTotalNfe || "0,00") && nfeFinancialIssue === "NOTA"
    );
  }, [itensTotalNfe, nfeFinancialIssue, pagtoTableCobranca]);

  const columnsTableCobranca = [
    {
      label: "Ações",
      format: (value) => {
        return (
          <>
            <Tooltip title="Editar">
              <IconButton
                onClick={() => {
                  handleOpenAndEditCobranca(value?.index);
                }}
                disabled={
                  (nfeFinancialIssue === "VENDA" ||
                    nfeFinancialIssue === "NOTA") &&
                  value?.cobrancaSituacaoValue === "50"
                }
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Deletar">
              <IconButton
                onClick={() => {
                  handleConfirmActionItem(
                    value?.index,
                    pagtoTableCobranca,
                    setPagtoTableCobranca
                  );
                }}
                disabled={
                  (nfeFinancialIssue === "VENDA" ||
                    nfeFinancialIssue === "NOTA") &&
                  value?.cobrancaSituacaoValue === "50"
                }
              >
                <DeleteOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      },
      align: "center",
      style: { minWidth: 125 },
    },
    {
      label: "Nro",
      id: "cobrancaNro",
      align: "center",
      style: { minWidth: 80 },
    },
    {
      label: "Dt Venc.",
      id: "cobrancaDtVencto",
      align: "center",
      style: { minWidth: 120 },
    },
    {
      label: "Valor Parc",
      id: "cobrancaValor",
      format: (value) => `R$ ${value.cobrancaValor}`,
      align: "center",
      style: { minWidth: 120 },
    },
    {
      label: "Vlr Pago",
      id: "cobrancaValorPago",
      format: (value) => `R$ ${value.cobrancaValorPago}`,
      align: "center",
      style: { minWidth: 120 },
    },
    {
      label: "Sit",
      id: "cobrancaSituacao",
      align: "center",
      style: { minWidth: 150 },
    },
    {
      label: "Destaca Danfe",
      id: "cobrancaDanfe",
      align: "center",
      format: (value) => {
        return (
          <>
            <Grid item>
              <FormControlLabel
                value="end"
                control={
                  <Switch
                    checked={value.cobrancaDestacaDanfe}
                    onChange={() => handleDetachDanfe(value.index)}
                    color="primary"
                    disabled={
                      (nfeFinancialIssue === "VENDA" ||
                        nfeFinancialIssue === "NOTA") &&
                      value?.cobrancaSituacaoValue ===
                        GlobalVariables.RecieveSituations.fullyLiquidated
                    }
                  />
                }
              />
            </Grid>
          </>
        );
      },
      style: { minWidth: 150 },
    },
  ];

  const columnsTablePagto = [
    {
      label: "Ações",
      format: (value) => {
        return (
          <>
            <Tooltip title="Editar">
              <span>
                <IconButton
                  disabled={
                    visualizationOnly ||
                    senderClifor === "F" ||
                    saleFinanceSwitch
                  }
                  onClick={() => {
                    handleOpenAndEditPayment(value.index);
                  }}
                >
                  <EditOutlinedIcon />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="Deletar">
              <span>
                <IconButton
                  disabled={
                    visualizationOnly ||
                    senderClifor === "F" ||
                    saleFinanceSwitch
                  }
                  onClick={() => {
                    handleConfirmActionItem(
                      value.index,
                      pagtoTableFormaPagto,
                      setPagtoTableFormaPagto
                    );
                  }}
                >
                  <DeleteOutlineOutlinedIcon />
                </IconButton>
              </span>
            </Tooltip>
          </>
        );
      },
      align: "center",
      style: { minWidth: 125 },
    },
    {
      label: "Forma Pagto",
      id: "pagtoFormaLabel",
      align: "center",
      style: { minWidth: 150 },
    },
    {
      label: "Valor",
      format: (value) => `R$ ${value.pagtoValor}`,
      style: { minWidth: 125 },
    },
    {
      label: "Troco",
      format: (value) => `R$ ${value.pagtoTroco}`,
      style: { minWidth: 125 },
    },
    {
      label: "A Vista/Prazo",
      id: "pagtoIndicadorLabel",
      align: "center",
      style: { minWidth: 150 },
    },
    {
      label: "Cnpj Cred",
      id: "pagtoCnpjCred",
      align: "center",
      style: { minWidth: 180 },
    },
    {
      label: "Int",
      id: "pagtoIntLabel",
      align: "center",
      style: { minWidth: 400 },
    },
    {
      label: "Bandeira",
      id: "pagtoBandeiraLabel",
      align: "center",
      style: { minWidth: 150 },
    },
  ];

  useEffect(() => {
    const someDateAfter = pagtoTableCobranca.some((charge) =>
      moment(charge?.cobrancaDtVenctoValue).isAfter(moment(headerDateJL))
    );

    if (someDateAfter) {
      const installmentPayment = nfeListPaymentIndicator.find(
        (indicator) => indicator.value === "1"
      );

      const updatedPaymentForm = pagtoTableFormaPagto.map((payment) => {
        return {
          ...payment,
          pagtoIndicadorValue: installmentPayment?.value,
          pagtoIndicadorLabel: installmentPayment?.label,
        };
      });

      setPagtoTableFormaPagto(updatedPaymentForm);
    }
    // eslint-disable-next-line
  }, [
    pagtoTableCobranca,
    headerDateJL,
    setPagtoTableFormaPagto,
    nfeListPaymentIndicator,
  ]);

  return (
    <>
      {modalFormaPagtoOpen && (
        <ModalEmissaoFormaPagto
          modalFormaPagtoOpen={modalFormaPagtoOpen}
          setModalFormaPagtoOpen={setModalFormaPagtoOpen}
          indexPayment={indexPayment}
        />
      )}
      {modalCobrancaOpen && (
        <ModalEmissaoCobranca
          modalCobrancaOpen={modalCobrancaOpen}
          setModalCobrancaOpen={setModalCobrancaOpen}
          indexCharge={indexCharge}
        />
      )}
      <FormaPagto>
        <Grid container spacing={4}>
          <Grow in={true}>
            <Grid item sm={6}>
              <Grid item sm={12}>
                <TableDefault
                  columns={columnsTablePagto}
                  values={pagtoTableFormaPagto}
                  tableTitle={
                    <Header>
                      <Grid container spacing={2}>
                        <Grid item sm>
                          <Chip
                            label="FORMA DE PAGAMENTO"
                            bgcolor="secondary"
                          />
                        </Grid>
                        <Tooltip
                          title={
                            senderClifor === "F" &&
                            headerTypeNfe?.value === "S" ? (
                              <>
                                <Typography>
                                  Desativado para destinatários do tipo
                                  'Fornecedor'.
                                </Typography>
                              </>
                            ) : (
                              ""
                            )
                          }
                        >
                          <Grid item>
                            <Btn
                              disabled={
                                visualizationOnly ||
                                (senderClifor === "F" &&
                                  headerTypeNfe?.value === "S") ||
                                saleFinanceSwitch
                              }
                              startIcon={<Icon>add</Icon>}
                              label="Adicionar"
                              onClick={() => {
                                setIndexPayment(null);
                                setModalFormaPagtoOpen(true);
                              }}
                            />
                          </Grid>
                        </Tooltip>
                      </Grid>
                    </Header>
                  }
                />
              </Grid>
            </Grid>
          </Grow>
          <Grow in={true} {...(true ? { timeout: 800 } : {})}>
            <Grid item sm={6}>
              <TableDefault
                columns={columnsTableCobranca}
                values={pagtoTableCobranca}
                tableTitle={
                  <Header>
                    <Grid container spacing={2}>
                      <Grid item sm>
                        <Chip
                          label="CONDIÇÃO DE PAGAMENTO"
                          bgcolor="secondary"
                        />
                      </Grid>
                      <Tooltip
                        title={
                          senderClifor === "F" &&
                          headerTypeNfe?.value === "S" ? (
                            <>
                              <Typography>
                                Desativado para destinatários do tipo
                                'Fornecedor'.
                              </Typography>
                            </>
                          ) : (
                            ""
                          )
                        }
                      >
                        <Grid item>
                          <Btn
                            startIcon={<Icon>add</Icon>}
                            label="Adicionar"
                            onClick={() => {
                              setIndexCharge(null);
                              setModalCobrancaOpen(true);
                            }}
                            disabled={
                              visualizationOnly ||
                              handleSumParcialAndFullLiquidated() ||
                              (senderClifor === "F" &&
                                headerTypeNfe?.value === "S") ||
                              saleFinanceSwitch
                            }
                          />
                        </Grid>
                      </Tooltip>
                    </Grid>
                  </Header>
                }
              />
            </Grid>
          </Grow>
        </Grid>
      </FormaPagto>
    </>
  );
};

export default TabEmissaoFormaPagto;
